// extracted by mini-css-extract-plugin
export default {"content":"style_content__eK90A","itemName":"style_itemName__3dOpv"};